import React from 'react';

const DoctorFooter: React.FC = () => {
  return (
    <div id="kt_app_footer" className="app-footer bg-base text-white" style={{ marginTop: 'auto' }}>
      <div className="app-container container-fluid d-flex flex-column flex-md-row flex-center flex-md-stack py-3">
        <div className="text-dark order-2 order-md-1">
          <span className="text-white fw-semibold me-1">{new Date().getFullYear()} &copy;</span>
          <a href="#" className="text-white">Fesilah</a>
        </div>
        <ul className="menu menu-gray-600 menu-hover-primary fw-semibold order-1">
          <li className="menu-item">
            <a href="#" className="menu-link text-white px-2">About</a>
          </li>
          <li className="menu-item">
            <a href="#" className="menu-link text-white px-2">Support</a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default DoctorFooter;

